import { useState } from 'react';
import { SelectFilter } from '@components/SelectFilter';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const SelectFilterSection = () => {
  const [selectFilterOpen, setSelectFilterOpen] = useState(false);
  const [selectFilterValue, setSelectFilterValue] = useState<string | null>(null);
  const [largeFilterOpen, setLargeFilterOpen] = useState(false);
  const [largeFilterValue, setLargeFilterValue] = useState<string | null>(null);

  return (
    <section className={styles.section}>
      <SectionHeader
        title="Select Filter"
        description="A dropdown filter component with trigger button, badge for selected count, and MenuSelect dropdown. Click outside or press Escape to close."
        figmaNodeId="310-7300"
        styles={styles}
      />

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Interactive Demo</h3>
        <div className={styles.selectFilterContainer}>
          <SelectFilter
            label="Business Types"
            items={[
              { value: 'dental', label: 'Dental Clinic' },
              { value: 'derma', label: 'Dermatology' },
              { value: 'eye', label: 'Eye Clinic' },
              { value: 'pharmacy', label: 'Pharmacy' },
              { value: 'laundry', label: 'Laundry' },
            ]}
            value={selectFilterValue}
            onChange={setSelectFilterValue}
            isOpen={selectFilterOpen}
            onOpenChange={setSelectFilterOpen}
          />
        </div>
        <p className={styles.hint}>
          Selected: <strong>{selectFilterValue || 'None'}</strong>
        </p>
        <p className={styles.hint}>
          Click the filter to open dropdown. Badge appears when an item is selected.
        </p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Size Variants</h3>
        <div className={styles.row}>
          <div className={styles.selectFilterStateDemo}>
            <span className={styles.stateLabel}>Regular (38px)</span>
            <SelectFilter
              label="Business Types"
              items={[
                { value: 'dental', label: 'Dental Clinic' },
                { value: 'derma', label: 'Dermatology' },
              ]}
              value={selectFilterValue}
              onChange={setSelectFilterValue}
              size="regular"
              isOpen={selectFilterOpen}
              onOpenChange={setSelectFilterOpen}
            />
          </div>
          <div className={styles.selectFilterStateDemo}>
            <span className={styles.stateLabel}>Large (52px)</span>
            <SelectFilter
              label="Business Types"
              items={[
                { value: 'dental', label: 'Dental Clinic' },
                { value: 'derma', label: 'Dermatology' },
              ]}
              value={largeFilterValue}
              onChange={setLargeFilterValue}
              size="large"
              isOpen={largeFilterOpen}
              onOpenChange={setLargeFilterOpen}
            />
          </div>
        </div>
        <p className={styles.hint}>
          Regular size (38px height) is the default. Large size (52px height) matches input field height.
        </p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>States</h3>
        <div className={styles.row}>
          <div className={styles.selectFilterStateDemo}>
            <span className={styles.stateLabel}>Default</span>
            <SelectFilter label="Business Types" items={[]} isOpen={false} onOpenChange={() => {}} />
          </div>
          <div className={styles.selectFilterStateDemo}>
            <span className={styles.stateLabel}>With Selection (Badge)</span>
            <SelectFilter
              label="Business Types"
              items={[{ value: 'dental', label: 'Dental Clinic' }]}
              value="dental"
              isOpen={false}
              onOpenChange={() => {}}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
